import { h } from 'preact';

import Badge from 'components/badge/badge';

export default class BadgeFocus extends Badge {
	renderBadgeContent(props) {
		return [
			this.renderAlert(props),
			super.renderBadgeContent(props)
		].filter(Boolean);
	}
}